module.exports = __webpack_public_path__ + "img/1585459615.e7a06a05.jpg";